import { useLanguageContext, useThemeContext } from "../../../context";
import AppModal from "../AppModal";
import { CreateCompanyComponent, CustomContainer } from "../../common";

const CreateCompanyModal = ({ toggle, setToggle, handleCreateCompany }) => {
  const { I18n } = useLanguageContext();
  const { theme } = useThemeContext();

  const handleClose = (event) => {
    setToggle(false);
  };

  return (
    <AppModal
      className="createCustomerModal"
      toggle={toggle}
      handleClose={handleClose}
      title={I18n.create_company}
    >
      <CreateCompanyComponent handleSelect={handleCreateCompany} />
    </AppModal>
  );
};

export default CreateCompanyModal;
